import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './Footer.css';
import shared from '../LandingPage/shared/landingShared.css';
import cs from '../commonStyle.css';
import messages from '../../locale/messages';
import Link from '../Link';
import {
  hasLandingAppLinks,
  isValidLandingSocialLink,
  LANDING_APP_LINKS,
  LANDING_SOCIAL_LINKS,
} from '../LandingPage/landingContent';

import logo from '../../../images/new-landing/logo.png';

import youtubeIcon from '/public/SiteIcons/youtubeIconBlack.svg';
import facebookIcon from '/public/SiteIcons/facebookIconBlack.svg';
import instaIcon from '/public/SiteIcons/InstagramIconBlack.svg';
import pinterestIcon from '/public/SiteIcons/pinterestIconBlack.svg';
import tiktokIcon from '/public/SiteIcons/tiktokIconBlack.svg';
import xIcon from '/public/SiteIcons/xIconBlack.svg';
import linkedInIcon from '/public/SiteIcons/linkedInIconBlack.svg';
import threadsIcon from '/public/SiteIcons/threadsIconBlack.svg';
import appStoreIcon from '../../../images/new-landing/appstore.svg';
import googlePlayIcon from '../../../images/new-landing/googleplay.svg';

const FOOTER_SOCIAL_ITEMS = [
  { key: 'youtube', icon: youtubeIcon, label: 'YouTube' },
  { key: 'facebook', icon: facebookIcon, label: 'Facebook' },
  { key: 'instagram', icon: instaIcon, label: 'Instagram' },
  { key: 'pinterest', icon: pinterestIcon, label: 'Pinterest' },
  { key: 'tiktok', icon: tiktokIcon, label: 'TikTok' },
  { key: 'x', icon: xIcon, label: 'X' },
  { key: 'linkedIn', icon: linkedInIcon, label: 'LinkedIn' },
  { key: 'threads', icon: threadsIcon, label: 'Threads' },
];

class Footer extends React.Component {
  static propTypes = {
    intl: PropTypes.any,
  };

  render() {
    const { intl } = this.props;
    const { appStoreUrl, playStoreUrl } = LANDING_APP_LINKS;
    const siteName = intl.formatMessage(messages.newLandingSiteName);

    const visibleSocialItems = FOOTER_SOCIAL_ITEMS.filter(
      ({ key }) => isValidLandingSocialLink(LANDING_SOCIAL_LINKS[key]),
    );
    const showSocials = visibleSocialItems.length > 0;
    const showStoreButtons = hasLandingAppLinks();

    return (
      <footer className={s.footer}>
        <div className={s.footerGrid}>
          <div className={s.footerCol}>
            <img
              src={logo}
              alt={intl.formatMessage(messages.newLandingMotoStreamLogoAlt)}
              className={s.footerLogo}
            />
            <p className={s.footerTagline}>
              <FormattedMessage {...messages.newLandingFooterTagline} />
            </p>
          </div>

          <div className={s.footerCol}>
            <h4><FormattedMessage {...messages.newLandingFooterExplore} /></h4>
            <ul>
              <li>
                <Link to="/s" className={s.footerLink}>
                  <FormattedMessage {...messages.newLandingFooterBookCar} />
                </Link>
              </li>
              <li>
                <Link to="/why-become-owner" className={s.footerLink}>
                  <FormattedMessage {...messages.newLandingFooterListCar} />
                </Link>
              </li>
              <li>
                <Link to="/about" className={s.footerLink}>
                  <FormattedMessage {...messages.newLandingFooterAbout} />
                </Link>
              </li>
              <li>
                <Link to="/contact" className={s.footerLink}>
                  <FormattedMessage {...messages.newLandingFooterContact} />
                </Link>
              </li>
            </ul>
          </div>

          <div className={s.footerCol}>
            <h4><FormattedMessage {...messages.newLandingFooterTrustTitle} /></h4>
            <ul>
              <li>
                <Link to="/privacy" className={s.footerLink}>
                  <FormattedMessage {...messages.privacyPolicy} />
                </Link>
              </li>
              <li>
                <Link to="/safety" className={s.footerLink}>
                  <FormattedMessage {...messages.newLandingFooterTrustSafety} />
                </Link>
              </li>
              <li>
                <Link to="/help" className={s.footerLink}>
                  <FormattedMessage {...messages.newLandingFooterHelp} />
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className={s.footerLink}>
                  <FormattedMessage {...messages.cookiePolicy} />
                </Link>
              </li>
            </ul>
          </div>

          <div className={s.footerCol}>
            {showSocials && (
              <div className={s.footerSocials}>
                {visibleSocialItems.map(({ key, icon, label }) => (
                  <a
                    key={key}
                    href={LANDING_SOCIAL_LINKS[key]}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={label}
                  >
                    <img src={icon} alt={label} className={s.socialImg} />
                  </a>
                ))}
              </div>
            )}

            {showStoreButtons && (
              <div className={s.footerApps}>
                {appStoreUrl && (
                  <a href={appStoreUrl} target="_blank" rel="noreferrer" className={shared.storeBtn}>
                    <img src={appStoreIcon} alt="" aria-hidden="true" />
                    <div className={shared.storeText}>
                      <span>{intl.formatMessage(messages.newLandingAppStoreText)}</span>
                      <strong>{intl.formatMessage(messages.newLandingAppStoreLabel)}</strong>
                    </div>
                  </a>
                )}
                {playStoreUrl && (
                  <a href={playStoreUrl} target="_blank" rel="noreferrer" className={shared.storeBtn}>
                    <img src={googlePlayIcon} alt="" aria-hidden="true" />
                    <div className={shared.storeText}>
                      <span>{intl.formatMessage(messages.newLandingPlayStoreText)}</span>
                      <strong>{intl.formatMessage(messages.newLandingPlayStoreLabel)}</strong>
                    </div>
                  </a>
                )}
              </div>
            )}
          </div>
        </div>

        <div className={s.footerBottom}>
          <p>© {siteName}</p>
        </div>
      </footer>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s, shared, cs),
)(Footer);
